export type ComplianceLevelCode =
  | "finance_share"
  | "investment_adviser"
  | "broker_securities";

export type AppComplianceLevelInfo = {
  levelCode: ComplianceLevelCode;
};

export const VIEWPOINT_REPORT_TYPES: Array<{ code: string; label: string }> = [
  { code: "stock_recommend", label: "推荐股票" },
  { code: "promised_return", label: "承诺收益" },
  { code: "political", label: "涉及政治" },
  { code: "porn_violence", label: "色情暴力" },
];

export const REPORT_TARGET_TYPE_VIEWPOINT = "viewpoint";

export type ViewpointReportStatus = "pending" | "completed";

export type ReportTargetContent = {
  spaceProductId?: string;
  targetId?: string;
  snapshot?: ViewpointReportSnapshot;
};

export type ViewpointReportRow = {
  id: string;
  reportTargetType: string;
  reportTargetTypeLabel: string;
  reportTargetContent: string;
  reportType: string;
  reportTypeLabel: string;
  detailNote: string;
  status: ViewpointReportStatus;
  statusLabel: string;
  handleResult: string;
  createdAt: string | Date;
  handledAt: string | Date;
};

export type ViewpointReportListResult = {
  total: number;
  list: ViewpointReportRow[];
};

export type ViewpointReportSubmitParam = {
  spaceId: string;
  spaceProductId: string;
  reportTargetType: string;
  targetId: string;
  reportType: string;
  detailNote?: string;
};

export type ViewpointReportSnapshot = {
  id?: string;
  content?: string;
  title?: string;
  titleMode?: boolean;
  publisherNickname?: string;
  publisherLabel?: string;
  publisherAvatarUrl?: string;
  publishedAt?: string;
  categoryName?: string;
  imageUrls?: string[];
};

export function parseReportTargetContent(json: string): ReportTargetContent | null {
  try {
    const o = JSON.parse(json) as ReportTargetContent;
    return o && typeof o === "object" ? o : null;
  } catch {
    return null;
  }
}

export function parseReportTargetSnapshot(contentJson: string): ViewpointReportSnapshot | null {
  const content = parseReportTargetContent(contentJson);
  return content?.snapshot && typeof content.snapshot === "object" ? content.snapshot : null;
}
